import { SxStyles } from '../../types';
import theme from '../../theme';
import { getResponsiveSize, laptopRatio } from '../../utils';

export const ControlsPractitionerStyle: SxStyles = {
  mediaModal: {
    '&.media-modal .modal-wrapper': {
      width: getResponsiveSize(755.9),
      height: getResponsiveSize(467.3),
    },
    '& .detail-modal': {
      position: 'absolute',
      left: '80%',
      width: '50%',
      right: '20',
      zIndex: 1000000,
    },
    '& .close-btn': {
      position: 'absolute',
      right: getResponsiveSize(8),
      top: getResponsiveSize(8),
      zIndex: '2',
    },
    '& .apply-buttons': {
      position: 'absolute',
      right: getResponsiveSize(0),
      bottom: getResponsiveSize(0),
      display: 'flex',
      mr: getResponsiveSize(16),
      mb: getResponsiveSize(6.4),

      '& .save-button': {
        backgroundColor: '#65B3CF',
        width: getResponsiveSize(85.1),
        height: getResponsiveSize(35),
        borderRadius: getResponsiveSize(4),
        fontFamily: theme.typography.mainFontFamily,
        fontSize: theme.typography.fs14,
        lineHeight: 2.2,
      },

      '& .cancel-btn': {
        borderColor: '#65B3CF',
        // borderColor: theme.palette.neutral?.lightBlue70,
        // color: theme.palette.neutral?.lightBlue70,
        color: '#65B3CF',
        marginRight: getResponsiveSize(16),
        width: getResponsiveSize(85.1),
        borderRadius: getResponsiveSize(4),
        height: getResponsiveSize(36),
        fontFamily: theme.typography.mainFontFamily,
        fontSize: theme.typography.fs14,
        lineHeight: 2.2,
      },
    },
    [theme.breakpoints.media?.laptop!]: {},
    [theme.breakpoints.media?.tablet!]: {},
  },
};
